import { sbaAxios  } from "../utils/sbaAxios";
import { getLeftMenuItems } from "../../config/apiConfig";
import {getUserSubMenu} from '../../config/apiConfig';
import {
   FETCH_LEFTMENU_BEGIN,
   FETCH_LEFTMENU_SUCCESS,
   FETCH_LEFTMENU_FAILURE
  } from '../constants/leftmenu';


export const getLeftMenuSection=(tenantId,userId,token)=> {
   return (dispatch) => {
    dispatch(fetchLeftMenuBegin());
    sbaAxios({
      url: `${getUserSubMenu}${tenantId},${userId}`,
      method: 'get',
    })
      .then(response => {
        const leftMenuItemData = response;
        dispatch(fetchLeftMenuSuccess(leftMenuItemData));
        return leftMenuItemData;
      })
      .catch((error) => {
        dispatch(fetchLeftMenuFailure(error));
        console.log(error);
      });
  };
}

export const fetchLeftMenuBegin = () => ({
  type: FETCH_LEFTMENU_BEGIN,
});

export const fetchLeftMenuSuccess = (leftMenuItemData) => ({
  type: FETCH_LEFTMENU_SUCCESS,
  payload: {leftMenuItemData},
});


export const fetchLeftMenuFailure = (errorMessage) => ({
  type: FETCH_LEFTMENU_FAILURE,
  payload: {errorMessage}
});

